var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":true},on:{"click":function($event){return _vm.$emit('sign-out')}}},[_c('img',{attrs:{"src":require('@/assets/exit.png'),"alt":"logout button","width":"30","height":"30"}})])}
var staticRenderFns = []

export { render, staticRenderFns }